import { DataIoService } from '../services/data-io.service';
import { MenuNode } from './MenuNode';

export class MenuLogic{

	static ioService:DataIoService;
	static criteria= new Map<string,Array<CallableFunction>>();
	static clear(){
		MenuLogic.criteria.clear();
	}
	static setIoService(service:DataIoService){
		MenuLogic.ioService = service;
	}
	
	static addCriteria(identifier:string,fn:CallableFunction){
		//console.log("adding criteria for:" +identifier);
		if(!MenuLogic.criteria.has(identifier)){

			MenuLogic.criteria.set(identifier,new Array<CallableFunction>());
		}
		MenuLogic.criteria.get(identifier).push(fn);
	}

	
	static isEnabled(_identifier:string|MenuNode):boolean{
		let identifier = '';
		if(typeof(_identifier)=="string"){
			identifier=_identifier;
		}
		if(_identifier instanceof MenuNode){
			identifier = _identifier.getIdentifier();
		}
		if(!MenuLogic.criteria.has(identifier)){
			return true;
		}
		let fnList = MenuLogic.criteria.get(identifier);
		if(fnList.length == 0){
			return true;
		}
		for(let fn of fnList){
			if(!fn(_identifier)){
				return false;
			}
		}
		return true;
	}
}